export const sanitizePhoneNumber = (tel: string) => {
  if (tel.match(/^\+47\d{8}$/)) return tel.slice(3);
  if (tel.match(/^0047\d{8}$/)) return tel.slice(4);
  if (tel.match(/^47\d{8}$/)) return tel.slice(2);
  return tel;
};
